import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { BOOK_URL, ASSETS } from "@/lib/site";

const links = [
  { label: "The Valve", href: "#valve" },
  { label: "How It Works", href: "#how" },
  { label: "Features", href: "#features" },
  { label: "Pricing", href: "#pricing" },
  { label: "About", href: "#about" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1], delay: 0.2 }}
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-[background-color,backdrop-filter,border-color] duration-500 ${
        scrolled
          ? "bg-black/60 backdrop-blur-xl border-b border-white/10"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10 h-20 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-3 group" data-testid="logo-link">
          <img
            src={ASSETS.logoHorizontal}
            alt="Leak SmartShield"
            data-testid="header-logo"
            className="h-14 sm:h-16 w-auto object-contain [filter:brightness(0)_invert(1)] group-hover:[filter:none] transition-[filter] duration-300"
          />
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className="font-mono text-[11px] uppercase tracking-[0.2em] text-white/60 hover:text-white transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href={BOOK_URL}
          data-testid="header-book-btn"
          className="group relative inline-flex items-center gap-2 rounded-full bg-white text-black px-5 py-2.5 text-[12px] font-semibold tracking-wide hover:bg-[#169ED9] transition-colors duration-300"
        >
          Free Assessment
          <span className="transition-transform duration-300 group-hover:translate-x-1">→</span>
        </a>
      </div>
    </motion.header>
  );
}
